import { render, staticRenderFns } from "./m-accord-texture-cut.vue?vue&type=template&id=d41e21f4&scoped=true&"
import script from "./m-accord-texture-cut.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-accord-texture-cut.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41e21f4",
  null
  
)

export default component.exports